'use client';
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth-store';
import { isFeatureEnabled } from '@/lib/supabase/feature-flags';
import { CARE_TODAY_V1_FLAG } from '@/lib/client-care-redesign/care-today-flag';

/**
 * Care Today is a default-OFF organisation opt-in. Unresolved, pending, missing
 * and failed reads all keep the existing client experience.
 */
export function useCareToday() {
  const user = useAuthStore((state) => state.user);
  const flag = useQuery({
    queryKey: [CARE_TODAY_V1_FLAG, user?.tenantId, user?.id],
    enabled: Boolean(user?.tenantId),
    queryFn: () => isFeatureEnabled(CARE_TODAY_V1_FLAG, user?.tenantId).catch(() => false),
    retry: false,
    staleTime: 60_000,
  });
  return { enabled: flag.data === true, pending: Boolean(user?.tenantId) && flag.isPending };
}
